import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HrAddPersonFilesPayload } from 'api/actions/hr-add-person-files/hr-add-person-files-payload';
import { HrAddPersonFilesPathParameters } from 'api/actions/hr-add-person-files/hr-add-person-files-path-parameters';
import { HrAddPersonFilesResponse } from 'api/actions/hr-add-person-files/hr-add-person-files-response';

type HrAddPersonFilesQueryParameters = Record<string, any>;

/**
 * The path of the HrAddPersonFiles action.
 */
export const hrAddPersonFilesActionPath = new SweetPath<keyof HrAddPersonFilesPathParameters>(
  '/api/hr/people/{personId}/files',
  { path: '{param}' }
);

/**
 * Creates a contextualized HrAddPersonFiles actions.
 */
export default function createHrAddPersonFilesAction(axios: AxiosInstance) {
  return function hrAddPersonFilesAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: HrAddPersonFilesPathParameters;
    query?: HrAddPersonFilesQueryParameters;
    payload: HrAddPersonFilesPayload;
  }) {
    const path = hrAddPersonFilesActionPath.insert(parameters);

    return axios.request<HrAddPersonFilesResponse, HrAddPersonFilesResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
